const details = [
  {
    icon: 'ri-mail-line',
    label: 'Email Address',
    value: 'info@devstander.com',
    href: 'mailto:info@devstander.com',
  },
  {
    icon: 'ri-phone-line',
    label: 'Phone Number',
    value: '+48 532 004 860',
    href: 'tel:+48532004860',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Mailing Address',
    value: 'Nowogrodzka 50/54 – 515\n00-695, Warsaw, Poland',
    href: null,
  },
  {
    icon: 'ri-time-line',
    label: 'Business Hours',
    value: 'Monday – Friday\n9:00 AM – 6:00 PM (CET)',
    href: null,
  },
];

export default function ContactDetails() {
  return (
    <div className="flex flex-col gap-8">
      {/* Info Header */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <span className="w-6 h-px bg-[#3B82F6]"></span>
          <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
            Get in Touch
          </span>
        </div>
        <h2 className="font-display text-2xl lg:text-3xl font-bold text-white leading-tight mb-3">
          Let&apos;s Start a Conversation
        </h2>
        <p className="text-slate-400 text-sm leading-relaxed">
          Whether you have a specific project in mind or just want to explore possibilities,
          we&apos;re happy to chat. Reach out and we&apos;ll respond within one business day.
        </p>
      </div>

      {/* Contact Details */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
        {details.map((detail) => (
          <div
            key={detail.label}
            className="flex items-start gap-4 bg-[#0C1220] border border-[#1A2740] rounded-xl p-5"
          >
            <span className="w-10 h-10 flex items-center justify-center bg-[#1E3A5F]/40 rounded-lg flex-shrink-0">
              <i className={`${detail.icon} text-[#3B82F6] text-lg`}></i>
            </span>
            <div>
              <p className="text-slate-500 text-xs uppercase tracking-wider font-semibold mb-1">
                {detail.label}
              </p>
              {detail.href ? (
                <a
                  href={detail.href}
                  className="text-white text-sm font-medium hover:text-[#3B82F6] transition-colors duration-200 cursor-pointer"
                >
                  {detail.value}
                </a>
              ) : (
                <p className="text-white text-sm font-medium whitespace-pre-line">
                  {detail.value}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Map */}
      <div className="rounded-xl overflow-hidden border border-[#1A2740] h-48">
        <iframe
          title="Devstander Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.7456893127636!2d21.0123!3d52.2319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecc7e0b8e5dc3%3A0x3a0b5e59a2a32c15!2sNowogrodzka%2050%2C%2000-695%20Warszawa%2C%20Poland!5e0!3m2!1sen!2spl!4v1700000000000!5m2!1sen!2spl"
          width="100%"
          height="100%"
          style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg)' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
